export default __webpack_public_path__ + "static/media/rabbit-white.f7ec00ea.png";